import { Injectable, EventEmitter } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { UserEntitlementCatalogValue } from '../models/UserEntitlements';
import { AuthService } from './auth.service';
import { EntitlementsProviderService } from './entitlements-provider.service';
import { mapAbilities, setAbilities } from "src/app/services/can";

@Injectable({
    providedIn: 'root'
})
export class UserEntitlementsService {

    // these rule are filtered from a master list of entitlements rules for all roles
    // the filtering is done by role.
    // in future we may have api return entitlements applicable to logged in users role
    // if user has more than one role then we should show a dropdown on the top nav bar where
    // user can select the role he wants to view site as. If user change selection then we should update ability to
    // reflect new roles ability rules.

    public onChange: EventEmitter<any> = new EventEmitter();
    private whenEntitlementsLoaded: Subject<boolean> = new ReplaySubject(1);
    private _loadPromise: Promise<void>;

    constructor(
        private entitlementsProviderService: EntitlementsProviderService,
        private authService: AuthService
    ) { }

    ensureEntitlementsAreLoaded(): Promise<void> {
        this._loadPromise = this._loadPromise || this.loadUserEntitlementsInternal();
        return this._loadPromise;
    }

    reset(): void {
        setAbilities([]);
    }

    private async loadUserEntitlementsInternal(): Promise<void> {
        let userAbilities: UserEntitlementCatalogValue[] = [];

        // the ensureLoggedIn() call won't be needed once we:
        // - have all the gateways getting tokens from the auth service
        // - stop redirecting back to our own app after logout
        await this.authService.ensureLoggedIn();

        // The first one is retrieved here because the platform code is the same for all of the userAccessDetails
        const userAccessDetails = this.authService.userAccessDetails;
        if (userAccessDetails && userAccessDetails.length > 0 && userAccessDetails[0].platform_code) {
            const platformCode = this.authService.userAccessDetails[0].platform_code;
            try {
                const userEntitlements = await this.entitlementsProviderService.getUserEntitlements(platformCode).toPromise();
                if (userEntitlements) {
                    userAbilities = mapAbilities(userEntitlements);
                }
            } catch (ex) {
                console.error(ex);
            }
        } else {
            const userEntitlements = JSON.parse(localStorage.getItem('userEntitlements'));

            if (userEntitlements) {
                userAbilities = mapAbilities(userEntitlements);
            }
        }

        setAbilities(userAbilities);

        // On entitlements updated emits event so the menu items can update their lists
        this.whenEntitlementsLoaded.next(true);
        this.onChange.emit(userAbilities);
    }
}
